
/**
 * 「SHIKAKU APP」 アイコン（正方形）
 */
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    fill: {
      type: String,
      default: '#FFFFFF',
    },
  },
})
